import { IconBooks, IconChartBar, IconPresentationAnalytics, IconHistory, IconPlugConnected, IconReceipt, IconTarget, IconUsers } from '@tabler/icons-react';
import type { Me, Role } from './api';

/** Разделы и кому они нужны. Права всё равно решает БД: меню только не показывает лишнего. */
export const NAV: { to: string; label: string; icon: typeof IconReceipt; roles: Role[] }[] = [
  { to: '/expenses', label: 'Затраты', icon: IconReceipt, roles: ['owner', 'finance', 'manager', 'dept_head'] },
  { to: '/metrics', label: 'Показатели дня', icon: IconChartBar, roles: ['owner', 'finance', 'manager', 'dept_head'] },
  { to: '/plans', label: 'Планы', icon: IconTarget, roles: ['owner', 'finance', 'manager', 'dept_head'] },
  { to: '/catalogs', label: 'Справочники', icon: IconBooks, roles: ['owner', 'finance', 'admin'] },
  { to: '/sources', label: 'Источники', icon: IconPlugConnected, roles: ['owner', 'finance', 'admin'] },
  { to: '/audit', label: 'Журнал', icon: IconHistory, roles: ['owner', 'finance', 'admin'] },
  { to: '/users', label: 'Пользователи', icon: IconUsers, roles: ['owner', 'admin'] },
  { to: '/dashboard', label: 'Дашборд', icon: IconPresentationAnalytics, roles: ['owner'] },
];

export const navFor = (me: Me | null) => NAV.filter((n) => me?.roles.some((r) => n.roles.includes(r.role)));
